/* Ordenacao das listas de filtro (Match Day).
 *
 * Os valores de Team/League chegam do servidor como CODIGOS de 3 digitos
 * (regra da loja: nenhum nome no HTML) e o md-team-names.js os reescreve pro
 * nome via dicionario do Worker. Como a ordem do servidor e numerica pelo
 * codigo, este script re-ordena a lista alfabeticamente pelo NOME assim que
 * todos os itens estiverem reescritos. Kit e Gender ganham ordem semantica
 * fixa (Home antes de Away etc.), como a referencia. Roda de novo a cada
 * re-render dos filtros (aplicar filtro troca o DOM da section inteira).
 */
(function () {
  "use strict";

  var aplicando = false;

  var ORDEM_KIT = ["Home", "Away", "Third", "Fourth", "Goalkeeper", "Pre-Match", "Training", "Special", "Retro"];
  var ORDEM_GENERO = ["Men", "Women", "Kids"];
  var ORDEM_IDADE = ["Adults", "Kids"];
  /* temporada em ordem cronologica DECRESCENTE (a mais nova primeiro), que e o
     que o cliente procura; alfabetica poria 21/22 na frente */
  var ORDEM_TEMPORADA = ["26/27", "25/26", "24/25", "23/24", "22/23", "21/22", "Retro"];
  var ORDEM_VERSAO = ["Fan", "Player Edition"];

  function textoDoItem(li) {
    var s = li.querySelector("[data-md-team-label]") || li.querySelector(".facet-checkbox__text-label");
    return ((s ? s.textContent : li.textContent) || "").replace(/^\s+|\s+$/g, "");
  }

  function ordemFixaDe(rotulos) {
    var listas = [ORDEM_KIT, ORDEM_GENERO, ORDEM_IDADE, ORDEM_TEMPORADA, ORDEM_VERSAO];
    for (var i = 0; i < listas.length; i++) {
      var ok = true;
      for (var j = 0; j < rotulos.length; j++) {
        if (listas[i].indexOf(rotulos[j]) === -1) { ok = false; break; }
      }
      if (ok && rotulos.length > 1) return listas[i];
    }
    return null;
  }

  function ordenarLista(ul) {
    var lis = [];
    for (var i = 0; i < ul.children.length; i++) lis.push(ul.children[i]);
    if (lis.length < 2) return;

    var rotulos = [];
    for (var j = 0; j < lis.length; j++) rotulos.push(textoDoItem(lis[j]));

    var fixa = ordemFixaDe(rotulos);
    var comCodigo = ul.querySelector("[data-md-team-label]");

    var ordenados;
    if (fixa) {
      ordenados = lis.slice().sort(function (a, b) {
        return fixa.indexOf(textoDoItem(a)) - fixa.indexOf(textoDoItem(b));
      });
    } else if (comCodigo) {
      /* so ordena quando TODOS os codigos ja viraram nome - antes disso a
         ordem numerica do servidor e igual a exibida e mexer seria em vao */
      var spans = ul.querySelectorAll("[data-md-team-label]");
      for (var k = 0; k < spans.length; k++) {
        if (spans[k].getAttribute("data-md-named") !== "1") return;
      }
      ordenados = lis.slice().sort(function (a, b) {
        var ta = textoDoItem(a).toLowerCase();
        var tb = textoDoItem(b).toLowerCase();
        return ta < tb ? -1 : ta > tb ? 1 : 0;
      });
    } else {
      return;
    }

    var mudou = false;
    for (var m = 0; m < ordenados.length; m++) {
      if (ordenados[m] !== lis[m]) { mudou = true; break; }
    }
    if (!mudou) return;

    /* insercao unica: mover um a um gera uma mutacao por item (242 numa lista de
       121) que voltam pro proprio observer; com o fragmento e uma so */
    aplicando = true;
    var pedaco = document.createDocumentFragment();
    for (var n = 0; n < ordenados.length; n++) pedaco.appendChild(ordenados[n]);
    ul.appendChild(pedaco);
    aplicando = false;
  }

  function passada() {
    if (aplicando) return;
    var listas = document.querySelectorAll(".facets__list, .facets__list--vertical, .mobile-facets__list");
    for (var i = 0; i < listas.length; i++) ordenarLista(listas[i]);
  }

  var agendado = false;
  function agendar() {
    if (agendado || aplicando) return;
    agendado = true;
    requestAnimationFrame(function () {
      agendado = false;
      passada();
    });
  }

  if (window.MutationObserver) {
    var obs = new MutationObserver(agendar);
    obs.observe(document.documentElement, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", passada);
  else passada();
  window.addEventListener("load", passada);
})();
